<template src="./ApiSalesforce.html"></template>
<script>
  import NavBar from '../tools/NavBar.vue';
  import axios from 'axios'; 
  import swal from 'sweetalert';
  import Setting from '@/models/setting.js';
  export default {
    name: 'ApiSalesforce',
    components: {
      NavBar
    },
    mounted(){
      this.loadyears();    
    },
    data: () => ({
      setting: new Setting(),
      isloading: false,
      isprocess: false,
      processTitle: '',
      processValue: 0,
      connect: 'disconnected',
      token_api: null,
      years: [],
      months: [
        { label: 'Enero', value: '01' },
        { label: 'Febrero', value: '02' },
        { label: 'Marzo', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Mayo', value: '05' },
        { label: 'Junio', value: '06' },
        { label: 'Julio', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Septiembre', value: '09' },
        { label: 'Octubre', value: '10' },
        { label: 'Noviembre', value: '11' },
        { label: 'Diciembre', value: '12' }
      ],
      headers: [
        { title: 'Campaña', key: 'landing' },
        { title: 'Documento', key: 'documento' },
        { title: 'Nombres', key: 'nombres' },
        { title: 'Apellidos', key: 'apellidos' },
        { title: 'Referencia', key: 'referencia' },
        { title: 'Fecha', key: 'fecha' },
        { title: 'Valor', key: 'valor' },
        { title: 'Estado', key: 'estado' },
      ],
      year: null,
      month: null,
      donations: []
    }),
    methods: {

      async connectApi(){
        if(this.connect == 'connected'){
          this.connect == 'disconnected'
          return;
        }
        try {
          await axios.get('https://dovimapi.uwcolombia.org/sf/connect', {
            headers: { Authorization: 'Bearer 2DClZhks2JU0O8kybSStZRGFg6TgwmwA5tKsGH4xcCitzBmtLVIIVCODp5tTpChu'}
          }).then(res => {
            const data = res.data;
            if(data.status){
              this.token_api = data.token;
              this.connect = 'connected';
            }else{
              this.connect = 'disconnected';
            }
          });
        } catch (error) {
          swal({title: "error", text: error.message, icon: "error",
            buttons: {text: "ACEPTAR"}
          });
        }
      },

      async loadyears(){        
        try {
          await axios.get(this.setting.params.api +'/admin/donaciones/years', {
            headers:{ Authorization: localStorage.getItem('token') }
          }).then(res => {
            const data = res.data.data;
            if(res.data.status){
              this.years = data;
            }
          });
        } catch (error) {
          swal({title: "error", text: error.message, icon: "error",
            buttons: {text: "ACEPTAR"}
          });
        }
      },

      async loadregister(){
        try {
          this.isprocess = true;
          await axios.get(this.setting.params.api + '/admin/salesforce/donaciones/'+this.year+'/'+this.month, {
            headers:{ Authorization: localStorage.getItem('token') }
          }).then(res => {
            const data = res.data.data;
            if(res.data.status){
              this.donations = data;
            }
            this.isprocess = false;
          });
        } catch (error) {
          this.isprocess = false;
          swal({title: "error", text: error.message, icon: "error",
            buttons: {text: "ACEPTAR"}
          });
        }
      },

      async sendregister(){
        try {
          if(this.connect === 'disconnected'){
            swal({title: "error", text: 'Api Not Connected, please connect first!', icon: "error",
              buttons: {text: "ACEPTAR"}
            });
            return;
          }

          if(!this.donations.length){
            swal({title: "error", text: 'No found data to upload', icon: "error",
              buttons: {text: "ACEPTAR"}
            });
            return;
          }
          this.isprocess = true;
          this.processValue = 0;
          //begin
          const segmento = Math.round(100 / this.donations.length);
          let cantidad = 0;
          let log = '';
          let error = '';
          for (const element of this.donations) {
            this.processTitle = `Procesados ${cantidad}/${this.donations.length} registros.`;

            const f = new FormData;
            f.append('envieroment', this.setting.params.env);
            f.append('data', JSON.stringify(element));
            await axios.post('https://dovimapi.uwcolombia.org/sf/donations', f, {
              headers: { Authorization: 'Bearer '+this.token_api }
            }).then(res => {
              const data = res.data;
              if(data.status){
                log += data.message;
              }else{
                error += data.message;
              }
            });
            this.processValue += segmento;
            cantidad++;
          }
          this.isprocess = false;
          swal({title: "Proceso finalizado", text: log, icon: "success",
            buttons: {text: "ACEPTAR"}
          }); 
          if(error){
            console.log(error);
          }       
          //end
        } catch (error) {
          this.isprocess = false;
          swal({title: "error", text: error.message, icon: "error",
            buttons: {text: "ACEPTAR"}
          });
        }
      }
    }
  }
</script>